import Highcharts from "highcharts"
class DrawHighcharts {
  constructor() {
    const allCharts = document.querySelectorAll('.highchart');

    if (document.documentElement.lang === "en") {
      Highcharts.setOptions({
        lang: {
          decimalPoint: ".",
          thousandsSep: ",",
          numericSymbols: null
        }
      });
    } else if (document.documentElement.lang === "de") {
      Highcharts.setOptions({
        lang: {
          decimalPoint: ",",
          thousandsSep: "'",
          numericSymbols: null
        }
      });
    }

    allCharts.forEach(chart => {
      if (chart.classList.contains('highchart--column')) {
        this.initColumn(chart);
      } else if (chart.classList.contains('highchart--pie')) {
        this.initPie(chart);
      } else {
        console.log("Unknown Chart type on " + chart.id);
      }
    });
  }

  initColumn(chart) {
    if (!!chart) {
      const undefined = '';
      const chartHeight = "300";

      const seriesArr = [];
      const json = JSON.parse(chart.innerHTML);

      try {
        seriesArr.push(json.data);
      } catch (error) {
        console.log("Invalid JSON on " + chart.id + ": " + error)
      }

      try {
        const chartType = 'column';

        const chartOptions = {
          title: {
            text: '',
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: false,
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
              },
            },
          },
          xAxis: {
            categories: json.cats,
            labels: {
              rotation: -90,
              useHTML: true,
            }
          },
          yAxis: {
            tickPositions: json.tickPositions,
            //min: yAxisMin,
            //max: yAxisMax,
            labels: {
              useHTML: true,
              formatter: function() {
                return Highcharts.numberFormat(this.value, -1, undefined, Highcharts.defaultOptions.lang.thousandsSep);
              }
            }
          },
          series: seriesArr,
          chart: {
            styledMode: true,
            height: chartHeight,
            type: chartType
          },
        };

        chart = Highcharts.chart(chart.id, chartOptions);
      } catch (error) {
        console.log("noChart" + ' ' + error)
      }
    }
  }

  initPie(chart) {
    if (!!chart) {
      const undefined = '';
      var fixedDecimals = true; // auf true stellen falls fix definierte Kommastellen
      var fixedDecimalCount = 1; // Anzahl fix definierte Kommastellen falls fixedDecimals true

      try {
        var json = JSON.parse(chart.innerHTML);
        var seriesArr = [];
        seriesArr.push(json.data);
      } catch (error) {
        console.log("Invalid JSON on " + chart.id + ": " + error)
      }

      var chartHeight = '218';
      var chartType = 'pie';

      const chartDiv = document.querySelector('#' + chart.id);
      //create outside Legend
      const legendDiv = document.createElement('div');
      legendDiv.id = chart.id + '-legend';
      chartDiv.parentNode.appendChild(legendDiv);

      var containerElement = document.querySelector('#' + chart.id);
      var chartOptions = {
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        chart: {
          styledMode: true,
          height: chartHeight,
          type: chartType,
          margin: [0, 0, 0, 0],
          events: {
            load: function () {
              var chart = this
              if (legendDiv) {
                legendDiv.innerHTML = '';
                legendDiv.classList.add('outside-legend');
                var iterator = '';

                iterator = chart.series[0].data;

                iterator.forEach(function (serie, i) {
                  var parent = document.createElement('div');
                  parent.classList.add('series-outside-legend-item');
                  parent.classList.add('series');
                  if (!serie.visible) {
                    parent.classList.add('inactive');
                  }
                  parent.setAttribute('data-index', i);
                  parent.setAttribute('data-colorIndex', serie.colorIndex);
                  parent.setAttribute("data-chartType", serie.type);
                  parent.innerHTML = serie.name; // Anzahl Kommastellen innerhalb von toFixed()
                  //parent.innerHTML = serie.name;
                  legendDiv.append(parent);
                });
              }
            },
          },
        },
        tooltip: {
          shadow: false,
          useHTML: true,
          valueSuffix: '%',
          valueDecimals: 1
          //valueDecimals: (fixedDecimals) ? fixedDecimalCount : undefined,
        },
        plotOptions: {
          pie: {
            size: '100%',
            borderRadius: 0,
            padding: 5,
            slicedOffset: 0,
            dataLabels: {
              enabled: false,
            }
          },
          series: {
            states: {
              hover: {
                halo: null,
              }
            }
          }
        },
        series: seriesArr,
      };
      var chart = Highcharts.chart(chart.id, chartOptions);

      var itemsArray = Array.prototype.slice.call(
        legendDiv.querySelectorAll('.series-outside-legend-item')
      );

      itemsArray.forEach((item, i) => {
        var index = item.getAttribute('data-index');
        var d = chart.series[0].data[index];

        item.addEventListener('click', (e) => {
          var index = item.getAttribute('data-index');
          var d = chart.series[0].data[index];
          let currentItems = Array.prototype.slice.call(document.querySelectorAll(legendSelector + ' .series-outside-legend-item[data-index="' + index + '"]'));
          currentItems.forEach(item => {
            if (item.classList.contains('inactive')) {
              item.classList.remove('inactive');
            } else {
              item.classList.add('inactive');
            }
          })

          if (d.visible) {
            d.setVisible(false);
          } else {
            d.setVisible(true);
          }
        });
      });
    }
  }
}

export default DrawHighcharts;
